<template>
  <div class="modal is-active">
    <div class="modal-background" @click="cancel"></div>
    <div class="modal-card">
      <header class="modal-card-head" :class="{ mobile: isMobile }">
        <p v-if="localItem.id" class="modal-card-title">
         {{ displayFPTitle(localItem.fireProtection)  }}
        </p>
        <p v-else class="modal-card-title">{{ $t('itemmodal.new_inventory') }}</p>
        <div
          v-if="isFireExtinguisher() && $isAllowedTo('floor_areas_edit')"
          class="header-select"
        >
          <p>{{ $t('itemmodal.inventory_group') }}</p>
          <v-select
            class="panel-select"
            v-model="chosenInventoryGroup"
            :options="fireProtectionGroupMap"
            :placeholder="$t('itemmodal.select_fire_protection')"
            :allowEmpty="false"
            :internalSearch="true"
            :showLabels="false"
            @input="filterFireProtections()"
            track-by="index"
            label="text"
          >
          </v-select>
        </div>
        <div
          v-if="isFireExtinguisher() && $isAllowedTo('floor_areas_edit')"
          class="header-select"
        >
          <p>{{ $t('itemmodal.inventory_type_short') }}</p>

  <TypeDropdown
    v-model="chosenInventoryType"
    :items="filterdfireProtections"
  />
        </div>
        <div v-else class="addmapitem_subtitle">
          <p>{{ $t('itemmodal.inventory_type') }}: {{ localItem.fireProtection.inventoryType }}</p>
        </div>
        <button class="delete" aria-label="close" @click="cancel"></button>
      </header>
      <section class="modal-card-body not-mobile">
        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="label white">{{ $t('itemmodal.year') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="number"
                  v-model="localYear"
                  :disabled="!$isAllowedTo('floor_areas_edit')"
                />
              </div>
            </div>
            <div class="field">
              <div class="label white">{{ $t('itemmodal.pos_no') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="number"
                  v-model.number="localItem.positionNumber"
                  :disabled="!$isAllowedTo('floor_areas_edit')"
                />
              </div>
            </div>
            <div class="field">
              <div class="label white">{{ $t('itemmodal.size') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.size"
                  :disabled="!$isAllowedTo('floor_areas_edit')"
                />
              </div>
            </div>
            <div class="field">
              <div class="label white">{{ $t('itemmodal.manufacturer') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.manufacture"
                  :disabled="!$isAllowedTo('floor_areas_edit')"
                />
              </div>
            </div>
            <div class="field">
              <div class="label white">{{ $t('itemmodal.other') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.other"
                  :disabled="!$isAllowedTo('floor_areas_edit')"
                />
              </div>
            </div>
            <div class="field">
              <div class="label white">{{ $t('itemmodal.placement') }}</div>
              <div class="control">
                <textarea
                  class="textarea no-resize"
                  rows="2"
                  v-model="localItem.placementDescription"
                  :disabled="!$isAllowedTo('floor_areas_edit')"
                />
              </div>
            </div>
   
          </div>
          <div class="column">
            <div class="field" v-for="field in visibleFields" :key="field">
              <div v-if="fieldLabels[field]" class="label white">
                <label>{{ $t(fieldLabels[field]) }}</label>
              </div>
              <div class="control">
                <input
                  class="input"
                  :type="numberFields.has(field) ? 'number' : 'text'"
                  v-model="localItem.mapItemExtra[field]"
                  :disabled="!$isAllowedTo('floor_areas_edit')"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-dark"
          :class="isLoading ? 'is-loading' : ''"
          @click="save"
          v-if="$isAllowedTo('floor_areas_edit')"
        >
          <span class="icon is-info"><i class="fas fa-save" /></span><span>{{ $t('itemmodal.save') }}</span>
        </button>
        <button
          class="button is-dark"
          @click="deleteItem"
          v-if="$isAllowedTo('floor_areas_edit') && localItem.fireProtection.id"
        >
          <span class="icon"><i class="fas fa-trash" /></span>
          <span>{{ $t('itemmodal.delete') }}</span>
        </button>
        <button
          class="button is-dark"
          @click="cancel"
          v-if="$isAllowedTo('floor_areas_edit')"
        >
          <span class="icon"><i class="fas fa-ban" /></span> <span>{{ $t('itemmodal.cancel') }}</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import iconMixin from "@/mixins/iconMixin.js";
import fireEquipmentService from "@/mixins/fireEquipmentService.js";
import TypeDropdown from '@/components/TypeDropdown.vue';
export default {
  mixins: [iconMixin],
  components: { TypeDropdown },
  props: {
    item: Object,
    fireProtections: Array,
    hasMapFile: Boolean,
  },
  data() {

    return {
      fireProtectionOptions: [],
      filterdfireProtections: [],
      chosenInventoryType: null,
      chosenInventoryGroup: [],
      fireProtectionGroupMap: [],
      localItem: { mapItemExtra: {} },
      isLoading: false,
      localYear: "",
     fieldLabels: fireEquipmentService.getFieldLabels(),
     fieldMap: fireEquipmentService.getFieldMap(),
     numberFields: new Set([
      "chargeYear","revisionYear","installationYear","testPressureYear",
      "BatteryInstallationYear","BatteryRevisionYear",
      "ElectrodesInstallationYear","ElectrodesRevisionYear",
      "fusibleLinkDegrees","gasspringRevisionYear"
    ])
    };
  },
  computed: {
    ...mapState("fireProtectionStore", ["fireExtinguishers"]),
    ...mapGetters("appStore", ["isMobile"]),
    year() {
      if (this.localYear) {
        return this.localYear;
      }

      return "";
    },
    visibleFields() {
      const type = this.localItem.fireProtection?.inventoryType;
      return fireEquipmentService.getVisibleFields(type);
    },
  },
  watch: {
    chosenInventoryType: function (to) {
      this.localItem.fireProtection = to;
    },
    year: function (val) {
      if (val.length >= 4) {
        this.localYear = val.substr(0, 4);
      }
    },
  },
  methods: {
     tTypeFromOption(option) {
    const type = option?.inventoryType || option?.fireProtection?.inventoryType || option;
    return this.tTypeKey(type);
  },
    getFireProtectionOptions() {
      if (this.hasMapFile && !this.isMobile) {
        let extinguisherOptions = JSON.parse(JSON.stringify(this.fireProtections)).reduce(
          (acc, fireprot) => {
            if (
              this.fireExtinguishers.some(
                (extinguisher) => extinguisher === fireprot.inventoryType
              )
            )
              acc.push(fireprot);

            return acc;
          },
          []
        );

        return extinguisherOptions;
      } else {
        return this.fireProtections;
      }
    },
    optionLabel(opt) {
      return this.displayFPTitle(opt);
    },
    filterFireProtections() {
      if (this.chosenInventoryGroup.index > -1) {
        this.filterdfireProtections = this.fireProtectionOptions.filter(
          (x) => x.fireProtectionType === this.chosenInventoryGroup.index
        );
        this.chosenInventoryType = this.filterdfireProtections[0];

        return;
      }

      this.filterdfireProtections = this.fireProtectionOptions;
      this.chosenInventoryType = this.filterdfireProtections[0];
    },
    save() {

      if (!this.localItem.mapItemExtra) this.localItem.mapItemExtra = {};

      const fields = fireEquipmentService.getVisibleFields(
        this.localItem.fireProtection?.inventoryType
      );

      const nextExtra = {};
      for (const f of fields) nextExtra[f] = this.localItem.mapItemExtra[f] ?? "";
      this.localItem.mapItemExtra = nextExtra;

      if (!this.isLoading) this.$emit("save", this.localItem);
      this.isLoading = true;
    },
    cancel() {
      this.$emit("cancel");
    },
    isFireExtinguisher() {
      if (this.hasMapFile && !this.isMobile) {
        return this.fireExtinguishers.some(
          (extinguisher) => extinguisher === this.localItem.fireProtection.inventoryType
        );
      } else {
        return true;
      }
    },
    deleteItem() {
      this.$emit("delete", this.localItem);
    },
  },
  created() {
 
    this.localItem = Object.assign({}, this.item);
  if (!this.localItem.mapItemExtra) {
    this.localItem.mapItemExtra = {};
  }

    if (this.item.fireProtection) {
      this.chosenInventoryType = this.item.fireProtection;
      this.localYear = this.localItem.year.substring(0, 4);
    } else {
      this.chosenInventoryType = Object.assign({}, this.fireProtections[0]);
      this.localItem.fireProtection = Object.assign({}, this.fireProtections[0]);
    }

    this.fireProtectionGroupMap = Object.values(this.getFireProtectionGroupMap()).map(
      (item, index) => {
        return { index, text: item };
      }
    );

    this.filterdfireProtections,
      (this.fireProtectionOptions = this.getFireProtectionOptions());
    this.fireProtectionGroupMap.unshift({ index: -1, text: this.$t('itemmodal.all_selected') });
    this.chosenInventoryGroup = this.fireProtectionGroupMap[0];
  },

  isInputField(field) {
    const textFields = ["Comment"]; // dessa är textarea
    return !textFields.includes(field);
  },
};
</script>
<style lang="scss" scoped>
.modal-card-head {
  display: block;
  flex-wrap: wrap;
  .delete {
    position: absolute;
    top: 0.65rem;
    right: 0.6rem;
  }
  &.mobile {
    .modal-card-title {
      min-width: 150px;
    }
  }
}
</style>
<style lang="scss">
.addmapitem_subtitle {
  font-size: 1.25rem;
  color: #f3f3f3;
  float: right;
}
.addmapitem_subtitle {
  margin-right: 20px;
}
.header-select {
  position: relative;
  // margin-left: auto;
  margin-top: 0.5rem;

  margin-bottom: -5px;
  // width: 200px;
  display: flex;
  p {
    white-space: nowrap;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
  }
}
</style>
